// extracted by mini-css-extract-plugin
module.exports = {"container":"Message-module__container--2Uh6A","message":"Message-module__message--ygBI7"};